export const transformResponsePreview = preview => {
  return {
    content: preview.content,
    subject: preview.subject,
  }
}

export const transformResponseLiquidPreviewError = error => {
  return {
    line: error.line,
    message: error.message,
  }
}
